import { useNavigate } from 'react-router-dom';
import DeviceThumbnail from '../../../../assets/images/device-thumbnail.png';
import S from './DeviceInfoStyles';

type Props = {
  title: string;
  description: string;
  link?: string;
};

function DeviceInfo({
  title, description, link,
}: Readonly<Props>): JSX.Element {
  const navigate = useNavigate();

  const handleClick = (): void => {
    if (link) navigate(link);
  };

  return (
    <S.Wrapper isDisabled={!link}>
      <button className="entity-preview" type="button" onClick={handleClick}>
        <div className="avatar">
          <img src={DeviceThumbnail} alt="device" />
        </div>
        <div className="description">
          <p className="title" title={title}>{title}</p>
          <p className="subtitle" title={description}>{description}</p>
        </div>
      </button>
    </S.Wrapper>
  );
}

export default DeviceInfo;
